import * as ss from 'superstruct';

/**
 * The configuration for sending offline conversions to Microsoft Ads. The
 * stream's ad account, which must be linked to our management customer, is
 * sent as the CustomerAccountId header.
 */
export const MicrosoftAdsConversionOutputStreamDestination = ss.type({
  name: ss.literal('microsoft-ads-conversion'),
  /**
   * The conversion name to apply the conversion to.
   */
  conversionName: ss.string(),
  /**
   * If we should send any identifying info in the conversion to Microsoft
   * (email, phone).
   */
  enhanced: ss.boolean(),
});

export type MicrosoftAdsConversionOutputStreamDestination = ss.Infer<
  typeof MicrosoftAdsConversionOutputStreamDestination
>;
